import React from 'react';
import { NavLink } from 'react-router-dom';
import iconClose from '../../assets/icons/close.svg';

export default function AppDrawer() {
  return (
    <>
      <div className="drawer-side">
        <label htmlFor="app-drawer" className="drawer-overlay" />
        <nav className="menu flex w-52 pt-6 bg-navy-blue">
          <div className="flex justify-end px-2">
            <label htmlFor="app-drawer" className="drawer-button z-50 mb-16 px-4">
            <img src={iconClose} alt="" className="w-8" /></label>
          </div>
          <ul className="app-drawer-links w-11/12 place-self-end font-light pl-4">
            <li>
              <NavLink to="/">
                home
              </NavLink>
            </li>
            <li>
              <NavLink to="/about">
                about
              </NavLink>
            </li>
            <li>
              <NavLink to="/companies">
                companies
              </NavLink>
            </li>
            <li>
              <NavLink to="/our-team">
                our team
              </NavLink>
            </li>
            <li>
              <NavLink to="/working-at-forager">
                working at forager
              </NavLink>
            </li>
            <li>
              <NavLink to="/news">
                news
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact">
                contact
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
}
